'use strict';

export class Header {

    #add_team_campaign_to_cart_button;
    #add_team_campaign_to_cart_form;

    constructor() {
        this.#add_team_campaign_to_cart_button = document.querySelector('.add-team-campaign-to-cart');
        this.#add_team_campaign_to_cart_form = document.querySelector('form.add_campaign_to_cart');

        this.addEvents();
    }

    addEvents(){
        if(this.#add_team_campaign_to_cart_form){
            document.addEventListener('click', (event)=>{
               if(event.target.matches('.add-team-campaign-to-cart') || event.target.closest('.add-team-campaign-to-cart')) {
                   event.preventDefault();
                   let form_submit_button = this.#add_team_campaign_to_cart_form.querySelector('button[type="submit"]');
                   if(form_submit_button){
                       form_submit_button.click();
                   }
               }
            });
        }
    }

}
